import { IPermissions } from '../types/permissions';

class PermissionService {
  private permissions: IPermissions;

  constructor(permissions: IPermissions) {
    this.permissions = permissions;
  }

  hasAccess(method: string, controller: string, action: string): boolean {
    if (this.permissions.hasFullAccess) return true;

    if (!this.permissions.permissions) return false;

    const permissionString = `${method}.${controller}${method === 'Table' || method === 'Processor' ? 'Controller' : ''}.${action}`;
    return this.permissions.permissions.includes(permissionString);
  }
}

export { PermissionService };